<template>
  <div style="min-width:1290px;" v-loading="loading">
    <MyBanner />
    <MyRight />
    <div>
      <div class="w1200">
        <div style="padding:20px 0;display: flex;justify-content: space-between;align-items: center;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>招标信息</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <div style="display: flex;">
            <div style="width: 70px;font-size:14px;margin-top:5px;">公告名称:</div>
            <el-input placeholder="请输入搜索关键字" size="default" style="width: 235px;" :prefix-icon="Search" v-model="input" clearable></el-input>
            <el-button type="primary" size="default" style="margin-left: 10px;background: rgba(0, 95, 46, 1);" @click="search">搜索</el-button>
          </div> -->
        </div>
        <div class="header-box">
          <div class="header-top">
            <div class="header">信息类型：</div>
            <div class="header-type" v-for="item in information" :key="item.value" @click="activeMes(item.name,item.value)" :class="{'active':activeNum1==item.value}">
              {{item.name}}
            </div>
          </div>
          <div class="line"></div>
          <div class="header-top">
            <div class="header">排序方式：</div>
            <div class="header-type" v-for="item in Sort" :key="item.id" @click="activeMess(item.value)" :class="{'active':activeNum2==item.value}">
              {{item.name}}
            </div>
          </div>
          <div class="line"></div>
          <div class="header-top">
            <div class="header">项目类别：</div>
            <div class="header-type" v-for="(item,index) in ProjectCategory" :key="item.id" @click="activeMessa(index,item.aicId)" :class="{'active':activeNum3==index}">
              {{item.aicName}}
            </div>
            <div class="input-box">
              <div style="width: 70px;font-size:14px;margin-top:5px;">公告名称:</div>
              <el-input placeholder="请输入搜索关键字" size="default" style="width: 235px;" :prefix-icon="Search" v-model="input" clearable></el-input>
              <el-button type="primary" size="default" style="margin-left: 10px;background: rgba(0, 95, 46, 1);" @click="search">搜索</el-button>
            </div>
          </div>
        </div>
        <div class="header-box" v-loading="loadingPage">
          <div v-for="item in mesageArr" :key="item.id" @click="detail(item,item.aicId)" style="cursor: pointer;">
            <div class="announcement-than">
              <div class="announcement">
                <div class="announcement-tip">{{zbName}}</div>
                <div class="announcement-time">{{item.bulletinName}}</div>
              </div>
              <!-- <div class="Time green" v-if="item.bulletinEndTime&&item.bulletinEndTime!=''">【{{item.bulletinEndTime.slice(0,11)}}】</div> -->
              <div v-if="activeNum1!=3" class="Time" :class="checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime) == '正在公示'?'green':'red'">
                【{{checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime)}}】
              </div>
            </div>
            <div class="announcement-message">
              <div class="announcement-mymesage">公告详情：</div>
              <div class="announcement-mymesage-box Time" :title="removeHtmlStyle(item.content)">{{removeHtmlStyle(item.content)}}</div>
            </div>
            <div class="announcement-flex">
              <div class="flex">
                <div class="title-box">招标单位：</div>
                <div class="content-box">{{item.tenderName}}</div>
              </div>
              <div class="flex" v-if="activeNum1!=3">
                <div class="title-box">截止时间：</div>
                <div class="content-box">{{item.bulletinEndTime?item.bulletinEndTime.slice(0,11):''}}</div>
              </div>
              <div class="flex">
                <div class="title-box">发布时间：</div>
                <div class="content-box">{{item.publishTime?item.publishTime.slice(0,11):''}}</div>
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end;padding: 20px 10px 0px 20px;">
            <el-pagination v-model:current-page="current" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :size="size" :disabled="disabled" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>
<script setup>
import { Search } from '@element-plus/icons-vue'
import MyRight from "@/components/RightFixd.vue";
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { findTenderBulletinType, findTenderProjectType, findSortType, pageFindTenderBulletin } from "@/api/PengfeiWebsite/index.js"
let router = useRouter()
let activeNum1 = ref(0);
let activeNum2 = ref(0);
let activeNum3 = ref(0);
let loading = ref(true)
let loadingPage = ref(false)
let input = ref('')
let zbName = ref('招标公告')
let total = ref()
let current = ref(1)
let pageSize = ref(10)
let size = ref('default')
let disabled = ref(false)
let seaching = ref(false)
let mesageArr = ref()
let StradeClassification = ref('')
let information = ref([])
let Sort = ref([])
let ProjectCategory = ref([])
let removeHtmlStyle = (html) => {
  const newHtml = html
    .replace(/<\s*script[^>]*>(.|[\r\n])*?<\s*\/script[^>]*>/gi, '')
    .replace(/<\s*style[^>]*>(.|[\r\n])*?<\s*\/style[^>]*>/gi, '')
    .replace(/<\/?[^>]+>/g, '')
    .replace(/&[a-z]+;/gi, '')
    .substring(0, 1000)
  return newHtml
}
let checkRegistrationStatus = (changeBulletinEndTime, bulletinEndTime) => {
  let OneEndTime = new Date(changeBulletinEndTime);
  let endTime = new Date(bulletinEndTime);
  let currentTime = new Date();
  if (changeBulletinEndTime != null && OneEndTime > currentTime) {
    return "正在公示";
  } else if (changeBulletinEndTime != null && OneEndTime < currentTime) {
    return "公示结束";
  } else if (bulletinEndTime != null && endTime > currentTime) {
    return "正在公示";
  } else if (bulletinEndTime != null && endTime < currentTime) {
    return "公示结束";
  }
}
let search = async () => {
  loadingPage.value = true
  current.value = 1
  seaching.value = true
  await GetNewsTable()

}
let activeMes = (name, num) => {
  zbName.value = name
  activeNum1.value = num
  current.value = 1
  GetNewsTable()
}
let activeMess = (num) => {
  activeNum2.value = num
  current.value = 1
  GetNewsTable()
}
let activeMessa = (num, aicCode) => {
  activeNum3.value = num
  current.value = 1
  StradeClassification.value = aicCode
  GetNewsTable()
}
let handleSizeChange = (val) => {
  pageSize.value = val
  GetNewsTable()
  window.scrollTo(0, 0)
}
let handleCurrentChange = (val) => {
  current.value = val
  GetNewsTable()
  window.scrollTo(0, 0)
}
let detail = (item, aicId) => {
  router.push({ path: '/platformAnnouncementsDetail', query: { ids: JSON.stringify(item), aicId: aicId } })
}
let GetNewsTable = async () => {
  pageFindTenderBulletin({ page: current.value, rows: pageSize.value, bulletinType: activeNum1.value, sortType: activeNum2.value, aicId: StradeClassification.value ? StradeClassification.value : null, bulletinName: input.value }).then(res => {
    mesageArr.value = res.rows
    console.log("res.rows",res.rows);
    console.log("mesageArr.value",mesageArr.value);
    total.value = res.total
  })
  loadingPage.value = false
}
onMounted(async () => {
  await findTenderBulletinType().then(res => {
    information.value = res
  })
  await findSortType().then(res => {
    Sort.value = res
  })
  await findTenderProjectType().then(res => {
    ProjectCategory.value = res.data
        // 数组的首位为全部
    ProjectCategory.value.unshift({ aicId: null, aicName: '全部' })
  })
  await GetNewsTable()
  loading.value = false
})
</script>
<style scoped>
.green {
  color: rgba(0, 95, 46, 1) !important;
}
.red {
  color: rgba(255, 0, 0, 1) !important;
}
.announcement-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
}
.flex {
  display: flex;
  align-items: center;
}
.title-box {
  font-size: 14px;
  font-weight: 400;
  color: rgb(0, 0, 0);
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 95, 46, 1);
}
.announcement-mymesage-box {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.announcement-mymesage {
  width: 80px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
}
.announcement-message {
  display: flex;
  padding-bottom: 20px;
}
.announcement-tip {
  font-size: 14px;
  font-weight: 500;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgba(0, 95, 46, 1);
  padding: 5px;
  margin-right: 15px;
}
.announcement-time {
  font-size: 18px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.Time {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.announcement-than {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.announcement {
  display: flex;
  align-items: center;
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.input-box {
  position: absolute;
  right: 0;
  top: 15px;
  display: flex;
}
.line {
  width: 100%;
  height: 1px;
  background: rgb(233, 237, 242);
}
.header-box {
  border-radius: 4px;
  background: rgb(255, 255, 255);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 22px 30px;
  margin-bottom: 30px;
}
.header-top {
  display: flex;
  align-items: center;
  padding: 15px 0;
  position: relative;
}
.header-top:nth-child(1) {
  padding: 0 0 11px 0;
}
.header-top:nth-last-child(1) {
  padding: 15px 0 0px 0;
}
.header {
  font-size: 14px;
  font-weight: 700;
  line-height: 30px;
  color: rgb(51, 51, 51);
  text-align: left;
}
.header-type {
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
  color: rgb(51, 51, 51);
  text-align: left;
  margin-left: 30px;
  cursor: pointer;
}
.active {
  color: rgba(0, 95, 46, 1);
}
</style>